// stores/business/businessSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  businessId: null,
  businessInfo: null,
  roomId: null,
  tableId: null,
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setBusinessId: (state, action) => {
      state.businessId = action.payload;
    },
    setBusinessInfo: (state, action) => {
      state.businessInfo = action.payload;
    },
    setRoomId: (state, action) => {
      state.roomId = action.payload;
    },
    setTableId: (state, action) => {
      state.tableId = action.payload;
    },
    clearBusiness: (state) => {
      state.businessId = null;
      state.businessInfo = null;
      state.roomId = null;
      state.tableId = null;
    },
  },
});

export const { setBusinessId, setBusinessInfo, setRoomId, setTableId, clearBusiness } = businessSlice.actions;
export default businessSlice.reducer;
